<div *ngIf="viewState == 'LOADING'">
    <app-loader [style]="'color'" [description]="'Inloggen'"></app-loader>
</div>
<div *ngIf="viewState == 'LOGIN'">
    <div style="position:fixed;top:0;left:0;height:100%;width:100%;z-index:5;background:#EFEFEF;">
        <div class="card" style="max-width:500px;margin:30px auto;padding:50px;">
            <img src="/logo.svg" alt="Logo" style="width:100px;margin-bottom:10px;">
            <h5 class="card-title">Inloggen</h5>
            <p>Login met je NEO-account</p>
            <div class="login-button">
                <div class="login-button btn btn-primary" (click)="signIn()">Inloggen</div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="viewState == 'PAGE'">
    <section class="app">
        <app-navigation></app-navigation>
        <section class="main-container" [ngClass]="{'darkBackground': isOnDashboard()}">
            <app-header></app-header>
            <section class="main-content">
                <router-outlet></router-outlet>
            </section>
        </section>
        <footer></footer>
    </section>
</div>